import { render, staticRenderFns } from "./AppSysBar.vue?vue&type=template&id=460d8202&"
import script from "./AppSysBar.vue?vue&type=script&lang=ts&"
export * from "./AppSysBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports